import './ModelPanel.css';
import { useTranslation } from 'react-i18next';
import { useFeatureFlag } from '../../lib/analytics';
import { DropdownMenuCheckboxItem, DropdownMenuLabel } from '../../design-system';

// Auto-save type labels
const AUTO_SAVE_TYPES = [
  { key: 'dictionary', labelKey: 'modelPanel.autoSave.dictionary' },
  { key: 'grammar', labelKey: 'modelPanel.autoSave.grammar' },
  { key: 'explain', labelKey: 'modelPanel.autoSave.explanations' },
  { key: 'summarize', labelKey: 'modelPanel.autoSave.summaries' },
  { key: 'other', labelKey: 'modelPanel.autoSave.other' },
];

/** Settings content shared by chat and RAG, without a trigger or model picker. */
export default function ComposerSettingsItems({
  selectedModel,
  autoSaveSettings,
  updateAutoSaveSettings,
  streamingEnabled,
  setStreamingEnabled,
  thinkingEnabled,
  setThinkingEnabled,
  webSearchEnabled,
  setWebSearchEnabled,
}) {
  const { t } = useTranslation();
  const webSearchFlagEnabled = useFeatureFlag('web-search');
  return (
    <>
      {/* Streaming section - at top */}
      {streamingEnabled !== undefined && setStreamingEnabled && (
        <>
          <DropdownMenuLabel className="model-panel-section-label">{t('modelPanel.sections.display')}</DropdownMenuLabel>
          <DropdownMenuCheckboxItem
            checked={streamingEnabled}
            onCheckedChange={setStreamingEnabled}
            onSelect={event => event.preventDefault()}
          >
            <span className="model-panel-option-copy">
            <span>{t('modelPanel.streaming')}</span>
            {/* The explanation is short enough to stand under the label, so
                the row no longer needs a help toggle to hide it behind. */}
            <span className="model-panel-option-hint">{t('streaming.helpText')}</span>
            </span>
          </DropdownMenuCheckboxItem>
        </>
      )}

      {/* Thinking section — only for Google (Gemini) models */}
      {thinkingEnabled !== undefined && setThinkingEnabled && selectedModel?.startsWith('gemini') && (
        <>
          <DropdownMenuLabel className="model-panel-section-label">{t('modelPanel.sections.thinking')}</DropdownMenuLabel>
          <DropdownMenuCheckboxItem
            checked={thinkingEnabled}
            onCheckedChange={setThinkingEnabled}
            onSelect={event => event.preventDefault()}
          >
            <span>{t('modelPanel.enhancedThinking')}</span>
          </DropdownMenuCheckboxItem>
        </>
      )}

      {/* Web search section — gated by PostHog feature flag */}
      {webSearchFlagEnabled && webSearchEnabled !== undefined && setWebSearchEnabled && (
        <>
          <DropdownMenuLabel className="model-panel-section-label">{t('modelPanel.sections.search')}</DropdownMenuLabel>
          <DropdownMenuCheckboxItem
            checked={webSearchEnabled}
            onCheckedChange={setWebSearchEnabled}
            onSelect={event => event.preventDefault()}
          >
            <span>{t('modelPanel.webSearch')}</span>
          </DropdownMenuCheckboxItem>
        </>
      )}

      {/* Auto-save section */}
      {autoSaveSettings && updateAutoSaveSettings && (
        <>
          <DropdownMenuLabel className="model-panel-section-label">{t('modelPanel.sections.autoSaveToComments')}</DropdownMenuLabel>
          <div>
            {AUTO_SAVE_TYPES.map(({ key, labelKey }) => (
              <DropdownMenuCheckboxItem
                key={key}
                checked={Boolean(autoSaveSettings[key])}
                onCheckedChange={checked => updateAutoSaveSettings(key, checked)}
                onSelect={event => event.preventDefault()}
              >
                <span>{t(labelKey)}</span>
              </DropdownMenuCheckboxItem>
            ))}
          </div>
        </>
      )}

    </>
  );
}
